import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, List, ListItemIcon, ListItemText, Popover, TypographyProps } from '@mui/material';
import React, { ReactNode } from 'react';
import { ListItem, ListItemButton } from 'src/components/Drawer/SidebarStyled';

// Components

const PopoverAction = ({
  listAction,
  primaryTypographyProps = {},
  disabled = false,
  id = '',
  children,
}: {
  listAction: {
    icon?: React.ReactNode;
    text?: string;
    action: (params?: ExpectedAny) => void;
    disabled?: boolean;
  }[];
  disabled?: boolean;
  primaryTypographyProps?: TypographyProps;
  id?: string;
  children?: ReactNode;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      {children ? (
        <span onClick={handleClick}>{children}</span>
      ) : (
        <IconButton color={disabled ? 'inherit' : 'suggestion'} onClick={handleClick} disabled={disabled}>
          <MoreVertIcon />
        </IconButton>
      )}
      <Popover
        id={open ? `simple-popover-${id}` : undefined}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List>
          {listAction.map((action, index) => {
            return (
              <ListItem key={`${action.text}-${index}`} disablePadding>
                <ListItemButton
                  sx={{
                    px: 2,
                    py: 1,
                    ':hover': {
                      '& .MuiSvgIcon-root path': {
                        fill: 'none',
                      },
                      '& .MuiTypography-root': {
                        color: 'inherit',
                      },
                    },
                  }}
                  onClick={() => {
                    action.action();
                    handleClose();
                  }}
                  disabled={action?.disabled}
                >
                  {action.icon && (
                    <ListItemIcon sx={{ color: 'inherit', minWidth: 'fit-content', mr: 1 }}>{action.icon}</ListItemIcon>
                  )}
                  <ListItemText
                    primary={action.text}
                    primaryTypographyProps={{ variant: 'body2', color: 'inherit', ...primaryTypographyProps }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </React.Fragment>
  );
};

export default PopoverAction;
